import { FC } from "react";
import { ColumnInstance } from "react-table";
import Storefront from "../../../../../../models/Storefront";

type Props = {
  column: ColumnInstance<Storefront>;
};

const CustomHeaderColumn: FC<Props> = ({ column }) => (
  <>
    {column.Header && typeof column.Header === "string" ? (
      <th {...column.getHeaderProps()}>{column.render("Header")}</th>
    ) : (
      column.render("Header")
    )}
  </>
);

export { CustomHeaderColumn };